module.exports = __webpack_public_path__ + "tables/media/widget-menu.b9ed4545.svg";